/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as ClaimsRouteImport } from './routes/claims'
import { Route as ClosedLoopRouteImport } from './routes/closed-loop'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DataConfidenceRouteImport } from './routes/data-confidence'
import { Route as EffectivenessPreventionRouteImport } from './routes/effectiveness-prevention'
import { Route as ExecutiveRouteImport } from './routes/executive'
import { Route as FinancialRouteImport } from './routes/financial'
import { Route as FinancialIntelligenceRouteImport } from './routes/financial-intelligence'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PreventionRouteImport } from './routes/prevention'
import { Route as ProblemRecordsRouteImport } from './routes/problem-records'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ProgramsRouteImport } from './routes/programs'
import { Route as RecallSafetyRouteImport } from './routes/recall-safety'
import { Route as SafetyRouteImport } from './routes/safety'
import { Route as SignalsRouteImport } from './routes/signals'
import { Route as SuppliersRouteImport } from './routes/suppliers'
import { Route as Top5RouteImport } from './routes/top5'
import { Route as ProblemRecordIdRouteImport } from './routes/problem-record.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BriefRoute = BriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimsRoute = ClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => rootRouteImport,
} as any)
const ClosedLoopRoute = ClosedLoopRouteImport.update({
  id: '/closed-loop',
  path: '/closed-loop',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DataConfidenceRoute = DataConfidenceRouteImport.update({
  id: '/data-confidence',
  path: '/data-confidence',
  getParentRoute: () => rootRouteImport,
} as any)
const EffectivenessPreventionRoute = EffectivenessPreventionRouteImport.update({
  id: '/effectiveness-prevention',
  path: '/effectiveness-prevention',
  getParentRoute: () => rootRouteImport,
} as any)
const ExecutiveRoute = ExecutiveRouteImport.update({
  id: '/executive',
  path: '/executive',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialRoute = FinancialRouteImport.update({
  id: '/financial',
  path: '/financial',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialIntelligenceRoute = FinancialIntelligenceRouteImport.update({
  id: '/financial-intelligence',
  path: '/financial-intelligence',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const PreventionRoute = PreventionRouteImport.update({
  id: '/prevention',
  path: '/prevention',
  getParentRoute: () => rootRouteImport,
} as any)
const ProblemRecordsRoute = ProblemRecordsRouteImport.update({
  id: '/problem-records',
  path: '/problem-records',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsRoute = ProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => rootRouteImport,
} as any)
const RecallSafetyRoute = RecallSafetyRouteImport.update({
  id: '/recall-safety',
  path: '/recall-safety',
  getParentRoute: () => rootRouteImport,
} as any)
const SafetyRoute = SafetyRouteImport.update({
  id: '/safety',
  path: '/safety',
  getParentRoute: () => rootRouteImport,
} as any)
const SignalsRoute = SignalsRouteImport.update({
  id: '/signals',
  path: '/signals',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersRoute = SuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any)
const Top5Route = Top5RouteImport.update({
  id: '/top5',
  path: '/top5',
  getParentRoute: () => rootRouteImport,
} as any)
const ProblemRecordIdRoute = ProblemRecordIdRouteImport.update({
  id: '/problem-record/$id',
  path: '/problem-record/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/brief': typeof BriefRoute
  '/claims': typeof ClaimsRoute
  '/closed-loop': typeof ClosedLoopRoute
  '/compliance': typeof ComplianceRoute
  '/dashboard': typeof DashboardRoute
  '/data-confidence': typeof DataConfidenceRoute
  '/effectiveness-prevention': typeof EffectivenessPreventionRoute
  '/executive': typeof ExecutiveRoute
  '/financial': typeof FinancialRoute
  '/financial-intelligence': typeof FinancialIntelligenceRoute
  '/portfolio': typeof PortfolioRoute
  '/prevention': typeof PreventionRoute
  '/problem-records': typeof ProblemRecordsRoute
  '/profile': typeof ProfileRoute
  '/programs': typeof ProgramsRoute
  '/recall-safety': typeof RecallSafetyRoute
  '/safety': typeof SafetyRoute
  '/signals': typeof SignalsRoute
  '/suppliers': typeof SuppliersRoute
  '/top5': typeof Top5Route
  '/problem-record/$id': typeof ProblemRecordIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/brief': typeof BriefRoute
  '/claims': typeof ClaimsRoute
  '/closed-loop': typeof ClosedLoopRoute
  '/compliance': typeof ComplianceRoute
  '/dashboard': typeof DashboardRoute
  '/data-confidence': typeof DataConfidenceRoute
  '/effectiveness-prevention': typeof EffectivenessPreventionRoute
  '/executive': typeof ExecutiveRoute
  '/financial': typeof FinancialRoute
  '/financial-intelligence': typeof FinancialIntelligenceRoute
  '/portfolio': typeof PortfolioRoute
  '/prevention': typeof PreventionRoute
  '/problem-records': typeof ProblemRecordsRoute
  '/profile': typeof ProfileRoute
  '/programs': typeof ProgramsRoute
  '/recall-safety': typeof RecallSafetyRoute
  '/safety': typeof SafetyRoute
  '/signals': typeof SignalsRoute
  '/suppliers': typeof SuppliersRoute
  '/top5': typeof Top5Route
  '/problem-record/$id': typeof ProblemRecordIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/brief': typeof BriefRoute
  '/claims': typeof ClaimsRoute
  '/closed-loop': typeof ClosedLoopRoute
  '/compliance': typeof ComplianceRoute
  '/dashboard': typeof DashboardRoute
  '/data-confidence': typeof DataConfidenceRoute
  '/effectiveness-prevention': typeof EffectivenessPreventionRoute
  '/executive': typeof ExecutiveRoute
  '/financial': typeof FinancialRoute
  '/financial-intelligence': typeof FinancialIntelligenceRoute
  '/portfolio': typeof PortfolioRoute
  '/prevention': typeof PreventionRoute
  '/problem-records': typeof ProblemRecordsRoute
  '/profile': typeof ProfileRoute
  '/programs': typeof ProgramsRoute
  '/recall-safety': typeof RecallSafetyRoute
  '/safety': typeof SafetyRoute
  '/signals': typeof SignalsRoute
  '/suppliers': typeof SuppliersRoute
  '/top5': typeof Top5Route
  '/problem-record/$id': typeof ProblemRecordIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/brief'
    | '/claims'
    | '/closed-loop'
    | '/compliance'
    | '/dashboard'
    | '/data-confidence'
    | '/effectiveness-prevention'
    | '/executive'
    | '/financial'
    | '/financial-intelligence'
    | '/portfolio'
    | '/prevention'
    | '/problem-records'
    | '/profile'
    | '/programs'
    | '/recall-safety'
    | '/safety'
    | '/signals'
    | '/suppliers'
    | '/top5'
    | '/problem-record/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brief'
    | '/claims'
    | '/closed-loop'
    | '/compliance'
    | '/dashboard'
    | '/data-confidence'
    | '/effectiveness-prevention'
    | '/executive'
    | '/financial'
    | '/financial-intelligence'
    | '/portfolio'
    | '/prevention'
    | '/problem-records'
    | '/profile'
    | '/programs'
    | '/recall-safety'
    | '/safety'
    | '/signals'
    | '/suppliers'
    | '/top5'
    | '/problem-record/$id'
  id:
    | '__root__'
    | '/'
    | '/brief'
    | '/claims'
    | '/closed-loop'
    | '/compliance'
    | '/dashboard'
    | '/data-confidence'
    | '/effectiveness-prevention'
    | '/executive'
    | '/financial'
    | '/financial-intelligence'
    | '/portfolio'
    | '/prevention'
    | '/problem-records'
    | '/profile'
    | '/programs'
    | '/recall-safety'
    | '/safety'
    | '/signals'
    | '/suppliers'
    | '/top5'
    | '/problem-record/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BriefRoute: typeof BriefRoute
  ClaimsRoute: typeof ClaimsRoute
  ClosedLoopRoute: typeof ClosedLoopRoute
  ComplianceRoute: typeof ComplianceRoute
  DashboardRoute: typeof DashboardRoute
  DataConfidenceRoute: typeof DataConfidenceRoute
  EffectivenessPreventionRoute: typeof EffectivenessPreventionRoute
  ExecutiveRoute: typeof ExecutiveRoute
  FinancialRoute: typeof FinancialRoute
  FinancialIntelligenceRoute: typeof FinancialIntelligenceRoute
  PortfolioRoute: typeof PortfolioRoute
  PreventionRoute: typeof PreventionRoute
  ProblemRecordsRoute: typeof ProblemRecordsRoute
  ProfileRoute: typeof ProfileRoute
  ProgramsRoute: typeof ProgramsRoute
  RecallSafetyRoute: typeof RecallSafetyRoute
  SafetyRoute: typeof SafetyRoute
  SignalsRoute: typeof SignalsRoute
  SuppliersRoute: typeof SuppliersRoute
  Top5Route: typeof Top5Route
  ProblemRecordIdRoute: typeof ProblemRecordIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brief': {
      id: '/brief'
      path: '/brief'
      fullPath: '/brief'
      preLoaderRoute: typeof BriefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claims': {
      id: '/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof ClaimsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/closed-loop': {
      id: '/closed-loop'
      path: '/closed-loop'
      fullPath: '/closed-loop'
      preLoaderRoute: typeof ClosedLoopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-confidence': {
      id: '/data-confidence'
      path: '/data-confidence'
      fullPath: '/data-confidence'
      preLoaderRoute: typeof DataConfidenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/effectiveness-prevention': {
      id: '/effectiveness-prevention'
      path: '/effectiveness-prevention'
      fullPath: '/effectiveness-prevention'
      preLoaderRoute: typeof EffectivenessPreventionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/executive': {
      id: '/executive'
      path: '/executive'
      fullPath: '/executive'
      preLoaderRoute: typeof ExecutiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial': {
      id: '/financial'
      path: '/financial'
      fullPath: '/financial'
      preLoaderRoute: typeof FinancialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial-intelligence': {
      id: '/financial-intelligence'
      path: '/financial-intelligence'
      fullPath: '/financial-intelligence'
      preLoaderRoute: typeof FinancialIntelligenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prevention': {
      id: '/prevention'
      path: '/prevention'
      fullPath: '/prevention'
      preLoaderRoute: typeof PreventionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/problem-records': {
      id: '/problem-records'
      path: '/problem-records'
      fullPath: '/problem-records'
      preLoaderRoute: typeof ProblemRecordsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recall-safety': {
      id: '/recall-safety'
      path: '/recall-safety'
      fullPath: '/recall-safety'
      preLoaderRoute: typeof RecallSafetyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/safety': {
      id: '/safety'
      path: '/safety'
      fullPath: '/safety'
      preLoaderRoute: typeof SafetyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signals': {
      id: '/signals'
      path: '/signals'
      fullPath: '/signals'
      preLoaderRoute: typeof SignalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers': {
      id: '/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof SuppliersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/top5': {
      id: '/top5'
      path: '/top5'
      fullPath: '/top5'
      preLoaderRoute: typeof Top5RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/problem-record/$id': {
      id: '/problem-record/$id'
      path: '/problem-record/$id'
      fullPath: '/problem-record/$id'
      preLoaderRoute: typeof ProblemRecordIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BriefRoute: BriefRoute,
  ClaimsRoute: ClaimsRoute,
  ClosedLoopRoute: ClosedLoopRoute,
  ComplianceRoute: ComplianceRoute,
  DashboardRoute: DashboardRoute,
  DataConfidenceRoute: DataConfidenceRoute,
  EffectivenessPreventionRoute: EffectivenessPreventionRoute,
  ExecutiveRoute: ExecutiveRoute,
  FinancialRoute: FinancialRoute,
  FinancialIntelligenceRoute: FinancialIntelligenceRoute,
  PortfolioRoute: PortfolioRoute,
  PreventionRoute: PreventionRoute,
  ProblemRecordsRoute: ProblemRecordsRoute,
  ProfileRoute: ProfileRoute,
  ProgramsRoute: ProgramsRoute,
  RecallSafetyRoute: RecallSafetyRoute,
  SafetyRoute: SafetyRoute,
  SignalsRoute: SignalsRoute,
  SuppliersRoute: SuppliersRoute,
  Top5Route: Top5Route,
  ProblemRecordIdRoute: ProblemRecordIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
